export default "__VITE_ASSET__PpEwke$O__"